import { serviceMaker, methods, api } from "@/http/index.js";

export const getShiftsList = () =>
  serviceMaker(`/sessionconfigurations`, methods.GET, api.NGB);
export const getShiftById = (id) =>
  serviceMaker(`/sessionconfigurations/${id}`, methods.GET, api.NGB);
export const getShiftByName = (name) =>
  serviceMaker(`/sessionconfigurations/name/${name}`, methods.GET, api.NGB);
export const deleteShift = (id) =>
  serviceMaker(`/sessionconfigurations/${id}`, methods.DELETE, api.NGB);
export const getSessionMcodes = () =>
  serviceMaker(`/mcodes/Shift Management`, methods.GET, api.NGB);
export const createShift = (data) =>
  serviceMaker(`/sessionconfigurations`, methods.POST, api.NGB, data);
export const updateShift = (name, data) =>
  serviceMaker(`/sessionconfigurations/${name}`, methods.PUT, api.NGB, data);